import { ActionTypes, ReduxAction } from './types';
import { Dispatch } from 'redux';

export const setInitialization =
  (value: boolean) => (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_INITIALIZED,
      payload: value,
    });
  };
